const toFolderPathSet = (paths) => {
    if (paths instanceof Set) return new Set(paths);
    if (Array.isArray(paths)) return new Set(paths);
    return new Set();
};

const setsEqual = (left, right) => (
    left.size === right.size
    && [...left].every(value => right.has(value))
);

export const getDocumentFolderAncestorPaths = (folderPath) => {
    if (typeof folderPath !== 'string' || !folderPath) return [];

    return folderPath.split('/').reduce((paths, segment, index, segments) => {
        if (segment) paths.push(segments.slice(0, index + 1).join('/'));
        return paths;
    }, []);
};

export const setDocumentFolderExpanded = (expandedPaths, folderPath, shouldExpand) => {
    const previous = toFolderPathSet(expandedPaths);
    if (typeof folderPath !== 'string' || !folderPath) return previous;

    const next = new Set(previous);
    if (shouldExpand) {
        next.add(folderPath);
    } else {
        next.delete(folderPath);
    }

    return setsEqual(previous, next) ? expandedPaths : next;
};

export const expandDocumentFolderAncestors = (expandedPaths, folderPath) => {
    const previous = toFolderPathSet(expandedPaths);
    const next = new Set(previous);
    getDocumentFolderAncestorPaths(folderPath).forEach(path => next.add(path));
    return setsEqual(previous, next) ? expandedPaths : next;
};

export const pruneDocumentExpandedFolders = (expandedPaths, availablePaths) => {
    const previous = toFolderPathSet(expandedPaths);
    const available = toFolderPathSet(availablePaths);

    // An empty inventory is the loading/reset boundary, not authoritative
    // proof that every folder was deleted.
    if (available.size === 0) return expandedPaths;

    const next = new Set([...previous].filter(path => available.has(path)));
    return setsEqual(previous, next) ? expandedPaths : next;
};

export const reconcileRenamedDocumentExpandedFolders = (
    expandedPaths,
    sourcePath,
    targetPath,
    succeeded
) => {
    const previous = toFolderPathSet(expandedPaths);
    const next = new Set();

    previous.forEach(path => {
        if (succeeded && (path === sourcePath || path.startsWith(`${sourcePath}/`))) {
            next.add(`${targetPath}${path.slice(sourcePath.length)}`);
            return;
        }

        if (!succeeded && (path === targetPath || path.startsWith(`${targetPath}/`))) {
            return;
        }

        next.add(path);
    });

    return setsEqual(previous, next) ? expandedPaths : next;
};
